import React from "react";
import Hero from "./hero";

const index = () => {
  return (
    <div>
      <Hero />
    </div>
  );
};

export default index;
